<template>
  <div class="zc loginbody">
    <div class="main">
      <div class="new-login-box new-login-box1">
        <div class="coinbig-zcL" style="width: 730px">
          <div class="new-login-boxb">
            <div class="new-login-top-box">
              <div class="topLogin">
                <img :src="BASEURL+'static/logo.png'" alt="">
                <span>{{ APP_WINNY_NAME }}</span>
              </div>
              <!-- <div class="yz">
                <img src="../../../assets/images/loginYz.png" alt="">
              </div> -->
              <!-- <div class="coinbig-nasq">
                欢迎登录国商中心
              </div>
              <div class="registerRouter">
                <router-link tag="a" to="/register/info">注册</router-link>
              </div> -->
              <div class="tabWrap">
                <div :class="loginType==1 ? 'active' : ''" @click="changeTab(1)">密码登录</div>
                <div :class="loginType==2 ? 'active' : ''" @click="changeTab(2)">验证码登录</div>
                <!-- <div v-if="loginType==1" :class="loginType==1 && currentTab!=1 ? 'active' : ''" @click="changeTab">交易账户登录</div> -->
              </div>
              <el-form
                id="login"
                ref="ruleForm"
                :model="ruleForm"
                :rules="rules"
              >
                <!-- <el-form-item v-if="loginType==1 && currentTab == 0" prop="telJy" class="ctops">
                  <el-input
                    v-model="ruleForm.telJy"
                    type="text"
                    class="coinbig-yxs"
                    placeholder="请输入交易账户"
                  ></el-input>
                </el-form-item> -->
                <el-form-item prop="tel" class="ctops">
                  <el-input
                    v-model="ruleForm.tel"
                    type="text"
                    maxlength="11"
                    class="coinbig-yxs"
                    placeholder="请输入您的手机号"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="loginType==1" prop="passWord" class="ctops ctops1">
                  <el-input
                    v-model="ruleForm.passWord"
                    :type="passwordShow"
                    class
                    placeholder="请输入登录密码"
                    @keyup.enter.native="submitForm('ruleForm')"
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-view"
                      @click="changePasswordShow"
                    ></el-button>
                  </el-input>
                </el-form-item>
                <el-form-item v-if="loginType==2" prop="msgValidateCode" class="ctops">
                  <el-input v-model="ruleForm.msgValidateCode" class="msgYszmInput" placeholder="请输入验证码">
                    <el-button slot="append" :disabled="btnDisenable" class="btnGetYzm" :class="{enBtnGetYzm: isEnBtnGetYzm}" @click="getMsgYzm()">{{ btnMsgYzmVal }}</el-button>
                  </el-input>
                </el-form-item>
                <el-form-item class="ctops isAgree">
                  <!-- <input
                    v-model="checked"
                    type="checkbox"
                    class="changes enChanges"
                  > -->
                  <el-checkbox v-model="checked"></el-checkbox>
                  您已阅读并同意
                  <span @click="showAgreement(592)">&nbsp;《风险告知》</span>
                  <span @click="showAgreement(591)">《入市须知》</span>
                  <span @click="showAgreement(598)">《用户协议》</span>
                  <span @click="showAgreement(597)">《隐私政策》</span>
                  <!-- 和<span @click="showMark">《入市须知》</span> -->
                </el-form-item>
                <el-form-item class="login-zcyc">
                  <el-button
                    class="coinbig-zcyxb login-button"
                    :disabled="btnEnable"
                    @click="submitForm('ruleForm')"
                  >登录</el-button>
                </el-form-item>
              </el-form>
              <div class="service-phone" style="margin-top: 10px;cursor:pointer;">
                客服热线：<span style="color: black;">{{ APP_hotline }}</span>
              </div>
              <div class="btnWrapBottom">
                <!-- <div>
                  <div class="rightBtn changWay">
                    <span @click="goReg">还没有账号?去注册</span>
                  </div>
                </div> -->
                <!-- <div class="rightBtn changWay">
                  <span @click="changLoginWay"> {{ loginType==1?'验证码登录':'交易账户登录' }}</span>
                </div> -->
              </div>
              <!-- <div id="bottomSuport" class="bottomSuport">
                <p>登录注册遇到问题请拨打客服电话400-0521566</p>
                <p class="suport">技术支持：海达信通 (839209)</p>
              </div> -->

            </div>
          </div>
        </div>
        <!-- <div class="LoginBottom">
          <div class="leftBottom">
            <img src="../../../assets/images/downLoadCode2.png" alt="" width="100px">
            <p class="downTip">扫码进入小程序</p>
          </div>
          <div class="midBottom">
            <div class="left">
              <h3>
                硒交商城
                <p>随时随地 &nbsp; 便捷交易</p>
              </h3>
            </div>
          </div>
          <div class="midBottom">
            <img src="../../../assets/images/comhz.png" alt="" height="130px">
          </div>
          <div class="rightBottom">
            <img src="../../../assets/images/downLoadCode1.png" alt="" width="100px">
            <p class="downTip">扫码下载APP</p>
          </div>
        </div> -->
      </div>
      <!-- <entryAgreement ref="agreementOpen" @confirm="confirmAgree" />
      <entryAgreement1 ref="marketOpen" @confirm="confirmAgree" /> -->
      <cmsEntryAgreement ref="cmsEntryAgreement" @confirm="confirmAgree" />
    </div>
    <!-- <div class="btnDown">
      <div class="downWrap">
        <img src="../../../assets/images/downLoad.png" alt="">
      </div>
      <div class="textWrap">
        <p class="p1">促进商品流通</p>
        <p class="p1">服务实体经济</p>
        <p class="p2">扫描二维码下载APP</p>
      </div>
    </div> -->
  </div>
</template>
<script>
/* global http protocol util BaseApi*/
// import { mapGetters, mapActions } from 'vuex'
// import entryAgreement from '../../../components/base/entryAgreement/entryAgreement.vue'
// import entryAgreement1 from '../../../components/base/entryAgreement/entryAgreement1.vue'
import cmsEntryAgreement from '../../../components/base/entryAgreement/cmsEntryAgreement.vue'
// import md5 from 'js-md5'
export default {
  components: {
    // entryAgreement,
    // entryAgreement1,
    cmsEntryAgreement
  },
  data() {
    return {
      APP_WINNY_NAME: window.g.APP_TITLE_ALL,
      APP_hotline: window.g.APP_hotline,
      BASEURL: process.env.BASE_URL,
      currentTab: 1,
      loginType: 1, // 1手机号密码登录 2手机号短信登录
      passwordShow: 'password',
      ieoId: '',
      clientHeight: '600px',
      fullHeight: '300',
      captchaData: '',
      checked: false,
      labelPosition: 'right',
      btnEnable: false,
      btnDisenable: false,
      isEnBtnGetYzm: false,
      btnMsgYzmVal: '获取验证码',
      ruleForm: {
        tel: '',
        telJy: '',
        passWord: '',
        msgValidateCode: '',
        tupian: ''
      },
      rules: {
        tel: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: 'blur'
          },
          {
            min: 11,
            max: 11,
            message: '请输入11位手机号',
            trigger: 'blur'
          }
        ],
        telJy: [
          {
            required: true,
            message: '请输入交易账户',
            trigger: 'blur'
          }
        ],
        passWord: [
          {
            required: true,
            message: '请输入登录密码',
            trigger: 'blur'
          }
        ],
        msgValidateCode: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }
        ],
        tupian: [
          {
            required: true,
            message: '请输入图形验证码',
            trigger: 'blur'
          }
        ]
      },
      isEnPhoto: false,
      // 确认风险提示
      centerDialogVisible: false,
      checked1: false,
      disabled: true,
      queryStatementsData: null,
      fileName: '',
      checkcaptchaCode: '', // 验证码验证参数
      loginValue: {
        captchaCode: '', // 图形验证码
        captchaId: '', // 验证码序列号
        loginAccount: '', // 登录账号
        marketId: 0, // 市场id
        terminalType: 4, // 终端类型
        type: '1', // 登录方式 1 ：账号密码登录 2 短信验证码登录
        code: '', // 短信/邮箱验证码 false
        password: '', // 密码 false
        username: this.$route.query.username ? this.$route.query.username : ''
      }
    }
  },
  watch: {
    checked1() {
      if (this.checked1 == true) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    }
  },
  created: function() {},
  mounted() {
    const that = this
    that.fullHeight = document.documentElement.clientHeight - 300
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight
        that.fullHeight = window.fullHeight
      })()
    }
    // 当刷新页面时候获取一下localStorage里存的值
    this.getlocalStorage()
    // 当页面刷新时获取图片验证码
    // this.VerificationCode()
    // 当页面刷新的时候，如果input里面有值，则checked为选中状态
    if (this.ruleForm.tel != '') {
      this.checked = true
    }
    // this.setLanguageCss()
    this.getUrl()
  },
  methods: {
    findBankAccountTea() {
      http.postFront(protocol.param_findBankAccountTea).then(response => {
        var { value, code, message } = response.data
        if (Number(code) === 0) {
          if (value !== null &&
            JSON.stringify(value) !== '{}' &&
            value !== '0') {
            if (value.signFlag == 1) {
              localStorage.setItem('signTea', '1')
            } else {
              localStorage.setItem('signTea', '0')
            }
          } else {
            localStorage.setItem('signTea', '0')
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 查询认证信息
    getIdentificationStatus() {
      BaseApi.findBaseUserAuditByUserId().then((response) => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (
            value !== null &&
            JSON.stringify(value) !== '{}' &&
            value !== '0'
          ) {
            // 已认证
            if (value.auditStatus === 1) {
              localStorage.setItem('openTea', '1')
            } else {
              // 未认证
              localStorage.setItem('openTea', '0')
            }
          } else {
            localStorage.setItem('openTea', '0')
          }
        } else {
          this.$message(message)
        }
      })
    },
    goReg() {
      this.$router.push('/register/info')
    },
    changeTab(type) {
      this.loginType = type
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate()
      })
      // this.currentTab = 0
      // if (type === 0) {
      //   this.currentTab = 1
      //   this.loginType = 1
      // }
    },
    // 用户结算单查询
    queryStatements() {
      // const that = this
      // http.postFront(protocol.param_queryStatements).then((response) => {
      //   const { code, message, value } = response.data
      //   if (code == 0) {
      //     if (value.content && value.content.length > 0) {
      //       that.queryStatementsData = value.content[0].tradeDay
      //       that.fileName = value.content[0].fileName
      //       this.$confirm('是否下载上一交易日结算信息?', '提示', {
      //         confirmButtonText: '确定',
      //         cancelButtonText: '取消',
      //         type: 'warning'
      //       }).then(() => {
      //         that.statementsDownload()
      //       }).catch(() => {
      //       })
      //     }
      //   } else {
      //     this.$message(message)
      //   }
      // })
    },
    changLoginWay() {
      this.changeTab()
      this.loginType = this.loginType === 1 ? this.loginType = 2 : this.loginType = 1
      this.$refs['ruleForm'].clearValidate()
    },
    // 用户结算单下载
    statementsDownload() {
      protocol.param_statementsDownload.param.tradeDay = this.queryStatementsData
      http.postFrontBlob(protocol.param_statementsDownload).then((res) => {
        var blob = new Blob([res.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
        var downloadElement = document.createElement('a')
        var href = window.URL.createObjectURL(blob) // 创建下载的链接
        downloadElement.href = href
        downloadElement.download = this.fileName // 下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() // 点击下载
        document.body.removeChild(downloadElement) // 下载完成移除元素
        window.URL.revokeObjectURL(href) // 释放掉blob对象
      })
    },
    showAgreement(id) {
      this.$refs.cmsEntryAgreement.showDia(id)
    },
    confirmAgree() {
      this.checked = true
    },
    /* 确认风险提示*/
    // 存值
    setUserRiskTime() {
      let userId = this.$store.state.common.sessionInfo.userId
      userId = userId + 'Mid'
      const time = util.formatnewDay(Number(new Date()))
      const obj = {}
      obj.isRiskNote = true
      obj.date = time
      const objString = JSON.stringify(obj)
      window.localStorage.setItem(userId, objString)
      // this.confirmationRiskTips()
      this.$router.push('/mallIndex/equityMall')
      // 通知已正常登陆
      // this.queryStatements()
    },
    // 确定
    confirm() {
      this.centerDialogVisible = false
      if (this.checked1 == true) {
        this.setUserRiskTime()
      }
      this.checked1 = false
    },
    // 取消
    cancel() {
      this.centerDialogVisible = false
      this.checked1 = false
      this.$store.commit('setSessionInfo', '')
      this.$store.commit('marketStatusInNewTopline', '--')
      sessionStorage.clear()
    },
    // 判断是否确认过风险提示
    isRiskNote() {
      const sCookie = this.getCookie('isRiskNote')
      if (sCookie == 'true') {
        this.centerDialogVisible = false
        this.$store.commit('setriskNoteCookieMid', true)
      } else {
        this.centerDialogVisible = true
        this.$store.commit('setriskNoteCookieMid', false)
      }
    },
    // 确认风险提示
    confirmationRiskTips() {
      if (
        sessionStorage.getItem('sessionStr') &&
        sessionStorage.getItem('userId')
      ) {
        http.getNewPath2(protocol.confirmRiskWarning).then((response) => {
          const { code } = response.data
          if (code == '0') {
            this.$router.push('/mallIndex/equityMall')
          } else {
            this.$store.commit('setSessionInfo', '')
            this.$store.commit('marketStatusInNewTopline', '--')
            sessionStorage.clear()
          }
        })
      }
    },
    // 判断风险提示书是否存在/过期
    userRiskTimePastDue() {
      let userId = this.$store.state.common.sessionInfo.userId
      userId = userId + 'Mid'
      const sNowTime = util.formatnewDay(Number(new Date()))
      const sLocalMsg = window.localStorage.getItem(userId)
      let oLocalMsg
      if (sLocalMsg) {
        // 老账户
        oLocalMsg = JSON.parse(sLocalMsg)
        if (oLocalMsg.date != sNowTime) {
          // 超过
          this.centerDialogVisible = true
          this.$store.commit('setriskNoteCookieMid', false)
        } else {
          this.centerDialogVisible = false
          this.$router.push('/mallIndex/equityMall')
          this.$store.commit('setriskNoteCookieMid', true)
          // 通知已正常登陆
          // this.queryStatements()
        }
      } else {
        // 新账户
        this.centerDialogVisible = true
        this.$store.commit('setriskNoteCookieMid', false)
      }
    },
    /* 确认风险提示 end*/
    changePasswordShow() {
      if (this.passwordShow == 'password') {
        this.passwordShow = 'text'
      } else {
        this.passwordShow = 'password'
      }
    },
    getUrl() {
      const urlArr = window.location.href.split('%3FieoId%3D')
      this.ieoId = urlArr[1]
    },
    setTime(e, vueThis) {
      const _this = this
      e--
      vueThis.btnMsgYzmVal = e + 's'
      if (e > 0) {
        setTimeout(function() {
          _this.setTime(e, vueThis)
        }, 1000)
      } else {
        vueThis.btnMsgYzmVal = '获取验证码'
        vueThis.btnDisenable = false
      }
    },
    // 获取手机验证码
    getMsgYzm() {
      if (this.ruleForm.tel === null || this.ruleForm.tel === undefined || this.ruleForm.tel === '') {
        this.$message('请输入手机号码')
        return
      }
      if (!util.isPoneAvailable(this.ruleForm.tel)) {
        this.$message('请输入11位手机号')
        return
      }
      this.getPhoneRe()
      // const sendValue = {
      //   id: 46,
      //   loginAccount: this.ruleForm.tel
      // }
      // this.$options.methods.setTime(60, this)
      // this.btnDisenable = true
      // BaseApi.sendCaptcha(sendValue).then(response => {
      //   if (Number(response.data.code) === 0) {
      //     this.$message(' 验证码已发送，请查看手机')
      //   } else {
      //     this.$message(response.data.message)
      //   }
      // }).cache(error => {
      //   this.$message(error)
      // })
    },
    // 查询手机号是否注册
    getPhoneRe() {
      protocol.param_getCellphoneExists.param.loginAccount = this.ruleForm.tel
      http.postFront(protocol.param_getCellphoneExists).then(response => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            if (this.btnDisenable) {
              return
            } else {
              const sendValue = {
                id: 46,
                loginAccount: this.ruleForm.tel,
                code: '76ff9bee27790118a09fa33096fda87f'
              }
              this.$options.methods.setTime(60, this)
              this.btnDisenable = true
              BaseApi.sendCaptcha(sendValue).then(response => {
                if (Number(response.data.code) === 0) {
                  this.$message(' 验证码已发送，请查看手机')
                } else {
                  this.$message(response.data.message)
                }
              }).cache(error => {
                this.$message(error)
              })
            }
          } else {
            this.$message('该手机号未注册')
          }
        } else {
          this.$message(message)
        }
      })
    },
    submitForm(formName) {
      // const unabs = window.g.UNABLE_LOGIN
      // const tel1 = this.loginType == 1 && this.currentTab == 0 ? this.ruleForm.telJy : this.ruleForm.tel
      // if (unabs.indexOf(tel1) > -1) {
      //   this.$message('无登录权限')
      //   return
      // }
      this.$store.commit('setH_avilibleMargin', 0)
      if (!this.checked) {
        this.$message('请勾选阅读并同意《风险告知》《入市须知》《用户协议》和《隐私政策》')
        return
      }
      // if (this.ruleForm.tupian !== this.checkcaptchaCode) {
      //   this.$message('图形验证码错误')
      //   return
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const self = this
          const tel = self.ruleForm.tel
          // 向后台发送用户登录名和密码
          // this.loginValue.captchaCode = this.ruleForm.tupian // 图形验证码
          // captchaId
          this.loginValue.loginAccount = this.ruleForm.tel
          this.loginValue.loginWay = 1 // 1手机号 3 交易账户
          this.btnEnable = true
          this.loginValue.password = this.ruleForm.passWord
          this.loginValue.code = this.ruleForm.msgValidateCode
          let loginProtol = BaseApi.login
          if (this.loginType === 2) {
            loginProtol = BaseApi.codeLogin
          }
          // http.postFront(protocol.param_login).then((response) => {
          loginProtol(this.loginValue).then(response => {
            const { code, message, value } = response.data
            if (code == 0) {
              if (value && value.banTime) {
                this.$message(value.banTime)
                return
              }
              // 当记住密码的checbox选中时，像localStorage里存入一下用户输入的用户名和密码
              if (self.checked == true) {
                self.setlocalStorage(self.loginType == 1 && self.currentTab == 0 ? self.ruleForm.telJy : self.ruleForm.tel, self.ruleForm.passWord)
              } else {
                self.setlocalStorage('', '')
              }
              const sessionInfo = {}
              sessionInfo.isLogin = true
              sessionInfo.userId = value.userId
              sessionInfo.sessionStr = value.sessionStr
              sessionInfo.firmCode = value.userCode
              sessionInfo.tel = tel
              sessionInfo.firmId = value.firmId
              sessionInfo.userType = value.type
              sessionInfo.userName = value.userName
              sessionInfo.lnvitationCode = value.lnvitationCode
              this.$store.commit('setSessionInfo', sessionInfo)
              localStorage.setItem('myPhone', tel)
              const sessionStr = response.data.value.sessionStr
              const sessionUserId = response.data.value.userId
              const sessionFirmId = response.data.value.firmId
              const sessionFirmCode = response.data.value.userCode
              const sessionTel = tel
              const lnvitationCode = value.lnvitationCode
              const sessionUserType = response.data.value.type
              const userName = response.data.value.userName
              // 将session信息存到localstorage中
              sessionStorage.sessionStr = sessionStr
              sessionStorage.sessionUserId = sessionUserId
              sessionStorage.sessionFirmCode = sessionFirmCode
              sessionStorage.sessionTel = sessionTel
              sessionStorage.userType = sessionUserType
              localStorage.setItem('lnvitationCode_w', lnvitationCode)
              localStorage.setItem('userName', userName)
              localStorage.setItem('userCode', sessionFirmCode)
              // 修改请求参数的登录信息
              for (const item in protocol) {
                if (protocol[item].param) {
                  if ('sessionStr' in protocol[item].param) {
                    protocol[item].param.sessionStr = sessionStr
                    protocol[item].param.userId = sessionUserId
                  }
                }
              }
              for (const key in protocol) {
                if (protocol[key].param) {
                  if ('firmId' in protocol[key].param) {
                    protocol[key].param.firmId = sessionFirmId
                  }
                  if ('ffirmId' in protocol[key].param) {
                    protocol[key].param.ffirmId = sessionFirmId
                  }
                  if ('firmCode' in protocol[key].param) {
                    protocol[key].param.firmCode = sessionFirmCode
                  }
                  if ('tel' in protocol[key].param) {
                    protocol[key].param.tel = sessionTel
                  }
                }
                if (protocol[key].data) {
                  if ('firmIds' in protocol[key].data) {
                    protocol[key].data.firmIds = sessionFirmId
                  }
                  if ('firmId' in protocol[key].data) {
                    protocol[key].data.firmId = sessionFirmId
                  }
                }
              }
              this.getIdentificationStatus()
              this.btnEnable = false
              this.$router.push('/mallIndex/equityMall')
              // 登录成功之后跳转到首页
              // if (this.ieoId == undefined) {
              // this.$router.push('/')
              // } else {
              //   this.$router.push({
              //     name: 'ieo',
              //     query: {
              //       ieoId: this.ieoId
              //     }
              //   })
              // }
            } else {
              this.VerificationCode()
              this.$message(message)
              this.btnEnable = false
            }
          }).catch(() => {
            this.btnEnable = false
          })
        } else {
          return false
        }
      })
    },
    // 登录后发送短信验证码
    sendMsgLoginInformation() {
      protocol.param_sendMsgLoginInformation.param.params = [
        util.dateFormateC(new Date()), 'pc端'
      ]
      http.postFront(protocol.param_sendMsgLoginInformation).then(response => {
        // const { code, message } = response.data
        // console.log(`发送短信验证码  ${code}  ${message}`)
      })
    },
    // 判断当前用户是否修改过资金密码
    getMoneyPwdFlgByFirmId() {
      const that = this
      http.postFront(protocol.param_getMoneyPwdFlgByFirmId).then(response => {
        const { code, value } = response.data
        if (code === 0 || code === '0') {
          that.$store.commit('setChangeMarginPsd', value)
          // if (value === true) {
          //   that.$alert('登录后请先修改资金密码，否则无法进行交易', '提示', {
          //     confirmButtonText: '确定',
          //     callback: action => {
          //     }
          //   })
          // }
        }
      })
    },
    // 像localStorage里存入从页面获取的用户名和密码；
    setlocalStorage(c_tel, c_pwd) {
      localStorage.sitetel = c_tel
    },
    getlocalStorage: function() {
      this.ruleForm.tel = localStorage.getItem('sitetel') // 保存到保存数据的地方
    },
    // 点击获取验证码
    VerificationCode: function(a, b) {
      BaseApi.generateCaptcha().then(response => {
        if (response.data) {
          this.captchaData =
            'data:image/png;base64,' + response.data.value.data
          // 图片校验时的参数
          this.checkcaptchaCode = response.data.value.code
          this.loginValue.captchaId = response.data.value.id
        } else {
          this.$message(response.data)
        }
      })
    },
    // 商品策略查询
    queryCommodityStrategy() {
      const _this = this
      http.postFront(protocol.param_queryCommodityStrategy).then((response) => {
        const { code, message, value } = response.data
        if (code == 0) {
          this.$store.commit('setCommodityStrategy', value)
        } else {
          this.$message(message)
          setTimeout(() => {
            _this.queryCommodityStrategy()
          }, 1000)
        }
      }).catch((e) => {
        setTimeout(() => {
          _this.queryCommodityStrategy()
        }, 1000)
      })
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale =
        localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en':
          localStorage.setItem('isEnPhoto', true)
          this.isEnPhoto = localStorage.isEnPhoto
          break
        default:
          break
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../../assets/images/main.min.css';
@import '../../../assets/images/servicecenter.min.css';

.btnDown{
  display: flex;
  width: 730px;
  height: 146px;
  margin: 0 auto;
  margin-bottom: 86px;
  background: url('../../../assets/images/bottomImg.png') center center/cover no-repeat;
  .downWrap{
    display: flex;
    height: 100%;
    padding-right: 24px;
    align-items: center;
  }
  img{
    margin-left: 35px;
    width: 92px;
    height: 92px;
  }
  .textWrap{
    padding-top: 30px;
  }
  .p1{
    font-size: 20px;
  font-family: PingFang HK-Semibold, PingFang HK;
  font-weight: 600;
  color: #333333;
  }
  .p2{
    padding-top: 14px;
    font-size: 17px;
    font-family: PingFang HK-Semibold, PingFang HK;
    font-weight: 600;
    color: #0486FE;
  }
}
.main{
  min-height: 674px;
  // height: 970px;
  // background-color:#242E46;
  // background: linear-gradient(208deg, #3E3E3E 0%, #1E1E1E 100%);
  // background: url('../../../assets/images/loginBg.png') center center/cover no-repeat;
}
.new-login-box1{
  background-color:transparent;
  .new-login-boxb{
    padding-bottom:15px;
  }
  .coinbig-zcL{
    // margin-top: 50px;
    // height: 700px;
    background:#fff;
    border-radius:12px;
  }
  .btnWrapBottom{
    display: flex;
    justify-content: center;
  }
  .yz{
    width: 200px;
    position: absolute;
    top: -50px;
    right: 0;
    img{
      width: 100%;
    }
  }
  .tabWrap{
    display: flex;
    align-items: center;
    padding: 0 4px;
    margin: 0 auto;
    margin-top: 40px;
    margin-bottom: 34px;
    width: 265px;
    height: 48px;
    background: #F2F2F2;
    border-radius: 65px 65px 65px 65px;
    div{
      cursor: pointer;
      width: 132px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 20px;
      font-family: PingFang HK-Regular, PingFang HK;
      font-weight: 400;
      color: #B9B9B9;
    }
    .active{
      background: #FFFFFF;
      border-radius: 65px 65px 65px 65px;
      font-weight: 500;
      color: #000000;
    }
  }
  .topLogin{
    // width: 350px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
      width: 100px;
    }
    span{
      font-size:30px;
      color:#000000;
      font-weight: bold;
    }
  }
  .coinbig-nasq{
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #171C23;
    margin-bottom:20px;
  }
   .registerRouter{
     text-align: right;
   }
  .registerRouter a{
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #0486FE;
    cursor: pointer;
  }
  .login-zcyc{
      width: 100%;
      height:71px;
      margin:0 auto;
  }
}
.LoginBottom{
  margin-top:40px;
  padding:16px 35px;
  background-color:#334263;
  height:130px;
  display: flex;
  justify-content: space-between;
  align-items:center;
  border-radius: 4px;
  .leftBottom,.rightBottom{
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .midBottom{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .left{
    margin-left:10px;
    color:#fff;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    h3{
      font-size:16px;
    }
    h3,p{
     color:#fff;
    }
  }
  .midBottom{
    display: flex;
    justify-content: space-around;
  }
}
.downTip{
      font-size:14px;
      color:#8098C0;
      text-align:center;
      line-height: 24px;
    }
 .bottomSuport{
   margin-top:30px;
  p{
    text-align:center;
    font-family: PingFang HK-Regular, PingFang HK;
    font-weight: 400;
    font-size: 11px;
    color: #818181;
  }
  .suport{
    font-size: 12px;
    color: #B8B8B8;
    line-height: 17px;
  }
}

</style>
<style>
#login .coinbig-zcyxb {
  background: #0F0F0F;
  border-radius: 49px;
}
.loginbody {
  height: calc(100vh - 40px) !important;
  overflow: auto;
  min-height: 497px;
  background: url(../../../assets/images/loginBg.png) center center/cover
    no-repeat !important;
  background-size: 100% 100%;
}
 .rightBtn{
      text-align:right;
    }
    .changWay{
      font-size:14px;
      margin-top:20px;
      margin-bottom: 30px;
    }
    .rightBtn span{
          font-size:20px;
          color:#0486FE;
          font-weight: 500;
          cursor: pointer;
      }
#login .el-input__inner {
  color: rgba(0,0,0,0.8);
  width: 100%;
  height: 100%;
  /* padding: 8px 8px 8px 10px; */
  height: 48px;
  box-sizing: border-box;
  margin: 0 auto;
  border-radius: 4px;
  border: 1px solid #979797;
  background: #fff;
  cursor: pointer;
}
#login .isAgree .el-form-item__content {
  line-height: 10px;
}
#login .isAgree span{
  color:#0486FE;
  cursor: pointer;
}
#login .el-form-item__content {
  line-height: 40px;
}
.el-input-group__append{
  border-color:#979797;
  background-color:transparent ;
}

#login .el-input-group {
  height: 48px;
}
#login .imgYzm {
  border-radius: 0 2px 2px 0;
  height: 47px;
  margin-top: 1px;
  width: 100%;
  cursor: pointer;
}
#login .el-button--primary:hover,
#login .el-button--primary:focus,
#login.el-button:hover {
  background: linear-gradient(90deg, #2577e1, #3bb0e3, #4edcf5);
}
#login .el-form-item__content {
  line-height: 40px;
}
#login .el-input-group .el-input__inner {
  height: 48px;
}
#login .ctops1 .el-input__inner{
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
#login .changes {
}
#login .forget {
  float: right;
  color: rgb(69, 142, 255);
}
</style>
<style>
  .el-dialog__wrapper .el-form-item__label {
    color: #fff;
  }
  .el-dialog__wrapper .stop-profit-loss .el-dialog {
    width: 517px;
    height: 400px;
    border-radius: 10px;
  }
  .el-dialog__wrapper .stop-profit-loss .el-dialog__footer {
    padding:  20px;
  }
  .el-dialog__wrapper .stop-profit-loss .el-dialog__footer::after {
    content: "";
    display: block;
    clear: both;
  }
  .el-dialog__wrapper .el-cancel-btn span,
  .el-dialog__wrapper .el-confirm-btn span {
    color: #fff !important;
  }
  .el-dialog__wrapper .el-confirm-btn,
  .el-dialog__wrapper .el-cancel-btn {
    float: right;
    margin-right: 14%;
    width: 135px;
    height: 36px;
    line-height: 0px;
    border: 0;
    background-color: rgba(75, 85, 127, 1) !important;
  }
  .el-dialog__wrapper .el-confirm-btn {
    background-color: rgba(122, 152, 248, 1) !important;
  }
  .el-dialog__wrapper .el-table--enable-row-hover .el-table__body tr:hover>td{
    background-color: rgba(180,206,255,.04) !important;
  }
  .el-dialog__wrapper .dialog-footer{
    height: 40px;
  }

  .el-dialog__wrapper .el-button--primary span{
    color: #fff;
  }
</style>
